import { Component, OnInit, ViewChild } from "@angular/core";
import { ViewWillEnter, IonContent } from "@ionic/angular";
import { Router } from "@angular/router";
import { EmployeeListService } from "../../../../common/services/employee-listing.service";
import { RequestParams } from "../../../../common/rest-api/models/request-params";
import { GtrakAuthService } from "../../../../../app/features/authentication/services/gtrak-auth.service";
import { WebLoginDept } from "../../../account-management/models/web-login-dept.model";
import { ToasterService } from "../../../../common/services/toaster.service";
import { AccountManagementService } from "../../../account-management/services/account-management.service";

@Component({
  selector: "app-work-order-page",
  templateUrl: "work-order.page.html",
  styleUrls: ["./work-order.page.scss"],
})
export class WorkOrderPage implements OnInit, ViewWillEnter {
  lastName: string = "";
  @ViewChild(IonContent) content!: IonContent;
  public rows: any;

  currentRoute: string;
  seachByGarmentCode: boolean = false;
  totalPages: number = 0;
  totalElements: number = 0;
  costCenterString: string;
  requestParams: any;

  currPage: number;
  pageSize: number;

  loginDepts: WebLoginDept[];
  selectedCostCenter: string;
  loaded: boolean;
  customerCode: string;
  departmentCode: string;

  constructor(
    private router: Router,
    public authService: GtrakAuthService,
    private employeeListService: EmployeeListService,
    private toasterService: ToasterService,
    private accountManagementService: AccountManagementService
  ) {
    this.currentRoute = null;
  }
  async ngOnInit(): Promise<void> {
    //if cost center user get all the cost centers associated with that user
    this.loaded = false;
    await this.accountManagementService
      .GetCostCenters(this.authService.user.id)
      .then((res) => {
        const allOption = {
          login: '',
          customerCode: '',
          departmentCode: 'All'
        } as any;

        this.loginDepts = [allOption, ...res];
      });

    this.requestParams = new RequestParams();

    if (!this.authService.user.canViewWorkOrders) {
      this.router.navigate([this.authService.user.homeLocation]);
    }

    if (this.authService.user.isWearer) {
      const wearerRoute = `/work-order/employee/${this.authService.user.employeeCode}/${this.authService.user.customerCode}/${this.authService.user.departmentCode}`;
      this.router.navigate([wearerRoute]);
    }
    this.customerCode = this.authService.user.customerCode;

    if (this.authService.user.isCustomerUser) {
      this.requestParams.filters.CustomerCode =
        this.authService.user.customerCode;
    } else if (this.authService.user.isEmployeeUser) {
      this.requestParams.filters.EmployeeCode =
        this.authService.user.employeeCode;
    }
    this.costCenterString = (this.loginDepts || [])
      .map(c => c.departmentCode)
      .filter(code => code !== 'All')
      .join(',');
    if (this.costCenterString != null && this.costCenterString != "") {
      localStorage.setItem('costCenterString', this.costCenterString);
      this.requestParams.filters.CostCenter = this.costCenterString;
      //Aloha added 18/06/2026 - to filter by username when user is cost center user
      this.requestParams.filters.UserName = this.authService.user.id;
    }

    // For the listing view, we want to exclude any inactive employees.
    this.requestParams.filters.ExcludeInactive = true;
    this.requestParams.setOrdering("LastName", "asc");

    this.rows = [];
    this.currentRoute = this.router.url;

    this.currPage = 1;
    if (localStorage.getItem("pageSize") != null) {
      this.pageSize = Number(localStorage.getItem("pageSize"));
    }
    else {
      this.pageSize = 500;
    }

    //Sandeep commented
    //await this.getCustomers();
    //this.loaded = true;
  }

  async ionViewWillEnter(): Promise<void> {
    this.loaded = false;
    await this.accountManagementService
      .GetCostCenters(this.authService.user.id)
      .then((res) => {
        const allOption = {
          login: '',
          customerCode: '',
          departmentCode: 'All'
        } as any;

        this.loginDepts = [allOption, ...res];
      });
    this.costCenterString = (this.loginDepts || [])
      .map(c => c.departmentCode)
      .filter(code => code !== 'All')
      .join(',');
    if (this.costCenterString != null && this.costCenterString != "") {
      localStorage.setItem('costCenterString', this.costCenterString);
      this.requestParams.filters.CostCenter = this.costCenterString;
      //Aloha added 18/06/2026 - to filter by username when user is cost center user
      this.requestParams.filters.UserName = this.authService.user.id;
    }
    if (localStorage.getItem("pageSize") != null) {
      this.pageSize = Number(localStorage.getItem("pageSize"));
    }
    else {
      this.pageSize = 500;
    }
    if (this.requestParams != undefined) {
      this.lastName = '';
      if (!this.authService.user.isCostCenterUser) {
        delete this.requestParams.filters.CostCenter;
        //Aloha added 18/06/2026 - to remove the username filter when user is not cost center user
        delete this.requestParams.filters.UserName;
      }
      delete this.requestParams.filters.lastName;
      delete this.requestParams.filters.StopCode;
      delete this.requestParams.filters.StopOrLastName;
      this.requestParams.setPaging(this.currPage, this.pageSize);
      if (this.authService.user.isWearer) {
        const wearerRoute = `/work-order/employee/${this.authService.user.employeeCode}/${this.authService.user.customerCode}/${this.authService.user.departmentCode}`;
        this.router.navigate([wearerRoute]);
      }
      await this.getCustomers();
      this.loaded = true;
    }
  }

  async getCustomers(): Promise<void> {
    this.loaded = false;
    this.requestParams.setPaging(this.currPage, this.pageSize);
    var employees = await this.employeeListService.query(this.requestParams);

    this.totalElements = employees.totalRecords;
    this.totalPages = employees.totalPages;
    this.rows = employees.results;
    this.loaded = true;
  }

  async getDataByLastName(): Promise<void> {
    if (this.requestParams.filters.LastName)
      delete this.requestParams.filters.LastName;
    if (this.requestParams.filters.StopOrLastName)
      delete this.requestParams.filters.StopOrLastName;

    if (this.requestParams.filters.CostCenter == 'All' || this.requestParams.filters.CostCenter == undefined) {
      if (this.costCenterString != null && this.costCenterString != "") {
        this.requestParams.filters.CostCenter = this.costCenterString;
        //Aloha added 18/06/2026 - to filter by username when user is cost center user
        this.requestParams.filters.UserName = this.authService.user.id;
      }
    }
    this.currPage = 1;

    this.requestParams.filters.StopOrLastName = this.lastName;

    this.requestParams.setOrdering("LastName", "asc");

    await this.getCustomers();
  }

  getDataByCustomerAndDepartmentCode(): void {
    if (this.authService.user.customerCode?.length > 0 && this.customerCode !== this.authService.user.customerCode) {
      this.toasterService.presentToast('danger', '', 'Invalid Customer Code', 1600);
      this.customerCode = this.authService.user.customerCode;
      return;
    }

    if (this.requestParams.filters.CustomerCode)
      delete this.requestParams.filters.CustomerCode;
    if (this.requestParams.filters.DepartmentCode)
      delete this.requestParams.filters.DepartmentCode;

    this.currPage = 1;

    //set the filters
    //if just customer code
    if (this.customerCode && !this.departmentCode) {
      this.requestParams.filters.CustomerCode = this.customerCode;
    } else if (!this.customerCode && this.departmentCode) {
      this.requestParams.filters.DepartmentCode = this.departmentCode;
    } else if (this.customerCode && this.departmentCode) {
      this.requestParams.filters.CustomerCode = this.customerCode;
      this.requestParams.filters.DepartmentCode = this.departmentCode;
    }

    this.requestParams.setOrdering("LastName", "asc");

    this.getCustomers();
  }

  async getDataCostCenter(): Promise<void> {
    if (!isNaN(Number(this.lastName))) {
      //always delete the filters first
      if (this.requestParams.filters.LastName)
        delete this.requestParams.filters.LastName;
      if (this.requestParams.filters.StopCode)
        delete this.requestParams.filters.StopCode;
      if (this.requestParams.filters.CostCenter)
        delete this.requestParams.filters.CostCenter;
      //Aloha added 18/06/2026 - to remove the username filter when user is not cost center user
      if (this.requestParams.filters.UserName)
        delete this.requestParams.filters.UserName;
      if (this.requestParams.filters.StopOrLastName)
        delete this.requestParams.filters.StopOrLastName;

      if (!this.lastName && this.selectedCostCenter) {
        this.requestParams.filters.CostCenter = this.selectedCostCenter;
        //Aloha added 18/06/2026 - to filter by username when user is cost center user
        this.requestParams.filters.UserName = this.authService.user.id;
      } else if (this.lastName && !this.selectedCostCenter) {
        this.requestParams.filters.StopOrLastName = this.lastName;
      } else if (this.lastName && this.selectedCostCenter) {
        this.requestParams.filters.StopOrLastName = this.lastName;
        this.requestParams.filters.CostCenter = this.selectedCostCenter;
      }
      if (this.requestParams.filters.CostCenter == 'All' || this.requestParams.filters.CostCenter == undefined) {
        if (this.costCenterString != null && this.costCenterString != "") {
          this.requestParams.filters.CostCenter = this.costCenterString;
          //Aloha added 18/06/2026 - to filter by username when user is cost center user
          this.requestParams.filters.UserName = this.authService.user.id;
        }
      }
      this.currPage = 1;
      this.requestParams.setOrdering("LastName", "asc");

      await this.getCustomers();
    } else {
      //always delete the filters first
      if (this.requestParams.filters.LastName)
        delete this.requestParams.filters.LastName;
      if (this.requestParams.filters.StopCode)
        delete this.requestParams.filters.StopCode;
      if (this.requestParams.filters.CostCenter)
        delete this.requestParams.filters.CostCenter;
      //Aloha added 18/06/2026 - to remove the username filter when user is not cost center user
      if (this.requestParams.filters.UserName)
        delete this.requestParams.filters.UserName;
      if (this.requestParams.filters.StopOrLastName)
        delete this.requestParams.filters.StopOrLastName;


      if (!this.lastName && this.selectedCostCenter) {
        this.requestParams.filters.CostCenter = this.selectedCostCenter;
      } else if (this.lastName && !this.selectedCostCenter) {
        this.requestParams.filters.StopOrLastName = this.lastName;
      } else if (this.lastName && this.selectedCostCenter) {
        this.requestParams.filters.StopOrLastName = this.lastName;
        this.requestParams.filters.CostCenter = this.selectedCostCenter;
      }
      if (this.requestParams.filters.CostCenter == 'All' || this.requestParams.filters.CostCenter == undefined) {
        if (this.costCenterString != null && this.costCenterString != "") {
          this.requestParams.filters.CostCenter = this.costCenterString;
        }
      }
      this.currPage = 1;

      this.requestParams.setOrdering("LastName", "asc");

      await this.getCustomers();
      //  }
    }
  }

  async setPage(event: { pageNumber: number, pageSize: number; sortField?: string, sortDirection?: string }): Promise<void> {
    this.loaded = false;
    this.pageSize = event.pageSize;
    this.currPage = event.pageNumber;
    if (event.sortField == "") {
      this.requestParams.setOrdering("LastName", "asc");
    } else {
      this.requestParams.setOrdering(event.sortField, event.sortDirection);

    }
    await this.getCustomers();
    this.content.scrollToTop(500);
    this.loaded = true;
  }


  changeCostCenter(event): void {
    this.selectedCostCenter = event;
  }
  onStopCodeFilter(stopCode: string) {

    this.rows = this.rows.filter(row => row.stopCode === stopCode);
    this.currPage = 1;
  }

  onCostCenterFilter(deliveryAddress2: string) {

    this.rows = this.rows.filter(row => row.deliveryAddress2 === deliveryAddress2);
    this.currPage = 1;
  }

  GetRecentWorkOrder() {
    this.router.navigate([this.currentRoute + '/customer/get/' + this.authService.user.customerCode]);
  }

  onEnterKey(event: KeyboardEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (this.authService.user?.isCostCenterUser) {
      this.getDataCostCenter();
    } else {
      this.getDataByLastName();
    }
  }
}
